'use strict';

wbApp.directive('wbActivityCombo', ['$timeout', '$translate', 'activitySvc', '$q',
    function ($timeout, $translate, activitySvc, $q) {
        function formatResult(model) {
            if (!model) { return; }

            return model.name;
        }

        function formatSelection(model) {
            if (model) {
                return model.name;
            }

            return "";
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            scope: {
                semesterId: '='
            },
            link: function (scope, elm, attrs, ctrl) {

                let linkSemesterId = scope.semesterId;
                let activities;
                if (scope.semesterId) {
                    activities = activitySvc.getAllBySemesterIDAsync(scope.semesterId);
                } else {
                    let deferred = $q.defer();
                    activities = [];
                    activities.$promise = deferred.promise;
                    deferred.resolve(activities);
                }

                activities.$promise.then(function() {
                    $timeout(function () {
                        $(elm).select2({
                            placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_ACTIVITY'),
                            formatResult: formatResult,
                            formatSelection: formatSelection,
                            dropdownAutoWidth: true,
                            allowClear: false,
                            minimumResultsForSearch: -1,
                            id: function (activity) { return activity.activityID; },
                            data: activities
                        });

                        ctrl.$parsers.unshift(function (viewValue) {
                            if (!viewValue) {
                                return 0;
                            } else {
                                return parseInt(viewValue);
                            }
                        });

                        ctrl.$formatters.unshift(function (value) {
                            if (!value) {
                                return "0";
                            } else {
                                return value + "";
                            }
                        });

                        ctrl.$render = function () {
                            if (activities.$promise) {
                                activities.$promise.then(function () {
                                    $(elm).select2('val', ctrl.$viewValue);
                                });
                            } else {
                                $(elm).select2('val', ctrl.$viewValue);
                            }
                        }

                        scope.$watch('semesterId', function (newValue) {
                            if (!newValue) {
                                $(elm).select2('val', null);
                                ctrl.$setViewValue(null);
                                return;
                            }

                            if (newValue == linkSemesterId) {
                                return;
                            }
                            linkSemesterId = null;

                            activitySvc.getAllBySemesterIDAsync(newValue)
                                .$promise.then(function (newActivities) {
                                activities.length = 0;
                                activities.push.apply(activities, newActivities);

                                for (var i = 0; i < activities.length; i++) {
                                    if (activities[i].activityID == ctrl.$viewValue) {
                                        return;
                                    }
                                }

                                if (activities.length > 0) {
                                    $(elm).select2('val', activities[0].activityID);
                                    ctrl.$setViewValue(activities[0].activityID);
                                } else {
                                    $(elm).select2('val', null);
                                    ctrl.$setViewValue(null);
                                }
                            });
                        });

                        elm.bind("$destroy", function () {
                            elm.select2("destroy");
                        });

                        attrs.$observe('readonly', function (value) {
                            elm.select2('readonly', !!value);
                        });

                    }, 1);
                });
            }
        }
    }]);